export default "__VITE_ASSET__DQ0Jx$lo__"